import React from "react";

import { StyledSVG } from "../StyledIcon";

export const PTOIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 60 60"
      fill="none"
      {...props}
    >
      <rect
        x="6"
        y="10"
        width="48"
        height="40"
        rx="4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke={iconColor}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M13 14C13 10.4853 13 8.51472 13 5"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M54 21L6 21"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M11 26L19.4313 26C24.678 26 28.9313 30.2533 28.9313 35.5V35.5C28.9313 40.7467 33.1846 45 38.4313 45L49 45"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M47 14V5"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
    </StyledSVG>
  );
};
